import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = {
  class: "ellipsis",
  style: {"width":"130px"}
}

import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
    interface productI {
        cat_id:any,
        cat_name:string
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CooperationApply',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const groupString = store.state.user.userInfo.group_id
    const groupArray = groupString.split(',')
    const filters = reactive({
        name: '', // 姓名
        user_phone: '', // 手机号
        cat_name: '', // 产品名
        start_date: '', // 开始时间
        end_date: '', //  结束时间
        page: 1, // 当前页码
        page_size: 10, // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false, // 弹框
        selectedMessage:'', // 留言内容
        threshold: 13, // 阈值
    })
    // 关闭弹框
    const dialogBeforeClose = () => {
        state.dialogVisible = false
    }
    const showMessage = (notes) => {
        state.selectedMessage = notes
    }
    //合作申请列表
    const tableData = ref([])
    const cooperationTypes = ref<productI[]>([])
    const total = ref(0)
    //获取产品列表数据
    const getCooperationTypes = () => {
        proxy.$http.get('/admin/shops/shop_cooperate_name_list').then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

            // 根据角色过滤合作类型
            let filteredData = data
            if (groupArray.includes('1')) { 
                // 管理员 - 不限
            } else if (groupArray.includes('3')) { // 运营 - cat_id == 1
                filteredData = data.filter((item: productI) => item.cat_id == 1)
            } else if (groupArray.includes('20')) { // 销售 - cat_id == 2 或 5
                filteredData = data.filter((item: productI) => item.cat_id == 2 || item.cat_id == 5)
            } else if (groupArray.includes('18')) { // 商务 - cat_id == 3
                filteredData = data.filter((item: productI) => item.cat_id == 3)
            } else if (groupArray.includes('21')) { // 客服 - cat_id == 4
                filteredData = data.filter((item: productI) => item.cat_id == 4)
            }

            cooperationTypes.value = filteredData
            // 默认选中第一个，管理员无默认
            if (!groupArray.includes('1')) {
                filters.cat_name = filteredData[0].cat_name
            }
            getList()
        })
    }
    // 获取列表数据
    const getList = () => {
        // 管理员 - 不限
        if (!groupArray.includes('1') && !filters.cat_name) return proxy.$message({ type: 'error', message: '请选择合作产品' })
        proxy.$http.get('/admin/shops/get_shop_cooperate_list', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    // 导出
    const output = () => {
        // 管理员 - 不限
        if (!groupArray.includes('1') && !filters.cat_name) return proxy.$message({ type: 'error', message: '请选择合作产品' })
        window.open(`${Keys.baseUrl}/admin/shops/export_shop_cooperate?${joinParams({...filters,user_id:store.state.user.userInfo.id})}`)
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getCooperationTypes()
    })


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.name) = $event)),
        placeholder: "姓名",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.user_phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.user_phone) = $event)),
        placeholder: "手机号",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.cat_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.cat_name) = $event)),
        clearable: "",
        placeholder: "合作产品"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cooperationTypes.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.cat_id,
              label: item.cat_name,
              value: item.cat_name
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "提交开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "提交结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (output()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      ref: "multipleTableRef",
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: "姓名"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_phone",
          label: "电话"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_compnay",
          label: "公司"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_name",
          label: "合作产品"
        }),
        _createVNode(_component_el_table_column, {
          prop: "notes",
          label: "留言",
          width: "210"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(scope.row.notes), 1),
              (scope.row.notes && scope.row.notes.length >= state.threshold)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (state.dialogVisible = true,showMessage(scope.row.notes))
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("查看详情")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "提交时间",
          width: "180"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "留言详情",
      modelValue: state.dialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.dialogVisible) = $event)),
      "before-close": dialogBeforeClose
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(state.selectedMessage), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})